
<template>
    <div>
    <template  v-if="i.type=='String'">
        {{getDataForPath(entity,i.field)}}
    </template>

  <!--  -->
    <template  v-if="i.type=='Boolean'">
        {{getDataForPath(entity,i.field) | toSelect('IsAndNot')}}
    </template>

    <template  v-if="i.type=='Select'">
         {{getDataForPath(entity,i.field) | toSelect(i.forSelectStoreName)}}
    </template>

    <template  v-if="i.type=='DateTime'">
          {{getDataForPath(entity,i.field)}}
    </template>
    <template  v-if="i.type=='Radio'">
           <el-radio-group v-model="entity[i.field]">
                            <el-radio v-for="item in $store.state[i.forSelectStoreName]" :disabled="!!i.IsNotEdit" class="radio" :label="item.Value">{{item.Text}}</el-radio>
                 </el-radio-group>

                <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
    </template>
    <template  v-if="i.type=='Checkbox'">
         <el-checkbox-group v-model="entity[i.field]">
                    <el-checkbox v-for="item in $store.state[i.forSelectStoreName]" :disabled="!!i.IsNotEdit"
                              :label="item.Value"
                              >{{ item.Text }}</el-checkbox>
                </el-checkbox-group>


                <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
    </template>
    <template  v-if="i.type=='Textarea'">

                <pre style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{getDataForPath(entity,i.field)}}</pre>
    </template>

    <template  v-if="i.type=='FunZTreeSelect'">
              <el-cascader  v-if="$store.state[i.forSelectStoreName]"
              :placeholder="i.placeholder"
              :disabled="!!i.IsNotEdit" class="ivu-cascader ivu-cascader-show-clear" style="display: block;"
              :options="$store.state[i.forSelectStoreName]"
              v-model="i[i.forValueStoreName]"
              change-on-select></el-cascader>

              <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
    </template>
    <template  v-if="i.type=='CheckboxList'">
         <el-checkbox-group v-model="i[i.forValueStoreName]">
                    <el-checkbox :label="o.Value" :disabled="!!i.IsNotEdit"
                              v-for="o in $store.state[i.forSelectStoreName]">
                        <span>{{o.Text}}</span>
                    </el-checkbox>
                </el-checkbox-group>
                 <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
    </template>
    <template  v-if="i.type=='UploadImage'">

                    <div class="el-form-group">
                        <div class="">
                        <div style="display:none" :id="i.field+'_UploadImage'"><a>{{i.buttonName}}</a></div>
                        </div>
                        <img :class="i.class" v-if="entity[i.field]" :src="(Urlpath=='/'?'':Urlpath)+entity[i.field]"/>
                    </div>

                 <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
    </template>

    <template  v-if="i.type=='UploadFile'">

                    <div class="el-form-group">
                        <div class="">
                        <div style="display:none" :id="i.field+'_UploadFile'"><a>{{i.buttonName}}</a></div>
                        </div>
                        <a :class="i.class" target="_blank" v-if="entity[i.field]" :href="(Urlpath=='/'?'':Urlpath)+entity[i.field]">{{g('$点击下载')}}</a>
                    </div>

                 <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
    </template>

    <template  v-if="i.type=='Editor'">
            <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>

                 <quill-editor class="quill-editor"
                 :options="editorOption"
                    v-model="entity[i.field]">
                </quill-editor>

    </template>

    <template  v-if="i.type=='TagList'">

                <el-tag
                    :key="tag"
                    v-for="tag in entity[i.field]"
                    :closable="!i.hideNew"
                    :disable-transitions="false"
                    @close="function(){
                         if(i.OnRemove){
                              i.OnRemove(tag)
                          }
                    }">
                    {{getDataForPath(tag,i.tagField)}}
                </el-tag>

                <el-popover  placement="top" width="600" trigger="hover">

                <popover-item :config="i.popperConfig">
                </popover-item>

                <el-button style="display:none" slot="reference" v-if="!i.hideNew" class="button-new-tag" size="small"  @click="function(){
                         if(i.OnRemove){
                             i.OnNewClick()
                          }
                    }">+ New</el-button>
                </el-popover>


                <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>

    </template>


<template  v-if="i.type=='LabelSetting'">

                    <el-button slot="reference" v-if="!i.hideNew" class="button-new-tag" size="small"  @click="function(){
                         $router.push('/LabelSetting')
                        if(window.rootVue.thisWindow){
                            window.rootVue.thisWindow.LabelSetting_Key = i.fieldsKey;
                            window.rootVue.thisWindow.LabelSetting = entity[i.field];
                            window.rootVue.thisWindow.OnLabelSettingChange = function(LabelSetting){
                                $set(entity,i.field,LabelSetting)
                                window.rootVue.thisWindow.LabelSetting = LabelSetting;
                            }
                        }

                    }">{{g("$查看&设置")}}</el-button>

                 <div class="bs-example bs-example-bg-classes"
                     style="color:red"
                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
    </template>

</div>
</template>
<style>
.el-input__inner{
    height: 35px;
}
.el-select{
    width: 100%;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 100%;
}
.ql-toolbar.ql-snow .ql-formats{
    line-height :initial;
}
</style>

<script>
import gets from '@/model/language'
import { $Path,$Urlpath} from '@/config/config.js'


export default {
    props: [ 'entity','field'],
    data() {
        return {
            window:window,
            value: [1,6],
            pickerOptions0: {
            disabledDate(time) {
                return time.getTime() > Date.now();
            }
        },
        editorOption:{
            height:"100px"
        },
        pickerOptions1: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        }
    },
    created() {
            var c = this.field;

            if(c.isCheck===undefined){
                    c.isCheck= true;
            }

            if (!(c.initField === undefined)) {
                c.initField(this, function (nodes) {
                }, this.entity[c.field], c)
            }

    },
    computed: {
        Urlpath(){
            return $Path;
        },
        i(){
            return this.field
        }
    },
    mounted () {
            var gos =this;
            setTimeout(function() {
                  var arr =[];
                  const c = gos.field;
                  if(c){
                        if (c.type == 'UploadImage') {
                                function cd (data){
                                        return function(){
                                            return data;
                                        }
                                }
                                arr.push(cd(c))
                        }


                        for (const i of arr) {
                                const g = i();
                                WorkUpLoad({id:"#"+ g.field +"_UploadImage",server:$Urlpath+(g.path?g.path:"Upload/ImageFileUpload")}, function (f, p) {
                                 
                                   if(g.initField){
                                        g.initField(gos, function (nodes) {
                                        }, gos.entity[g.field], g,f, p)
                                    }else{
                                        gos.$set(gos.entity,g.field,p.Path)
                                    }
                                })
                        }

                        arr =[];
                        if (c.type == 'UploadFile') {
                                function cd (data){
                                        return function(){
                                            return data;
                                        }
                                }
                                arr.push(cd(c))
                        }


                        for (const i of arr) {
                                const g = i();
                                WorkUpLoad({id:"#"+ g.field +"_UploadFile",server:$Urlpath+(g.path?g.path:"Upload/FileUpload")}, function (f, p) {
                                    if(g.initField){
                                        g.initField(gos, function (nodes) {
                                        }, gos.entity[g.field], g,f, p)
                                    }else{
                                        gos.$set(gos.entity,g.field,p.Path)
                                    }
                                })
                        }

                   }

            }, 300);

    },
    methods: {
        g: gets,
        getDataForPath(d, path) {
            var todata = d;
            var ps = path.split('.')
            for (var i of ps) {
                try {
                    todata = todata[i];
                } catch (error) {
                    return '';
                }
            }
            return todata;
        },
        c(value ,selectedData) {
        }
    },
    watch: {
        entity: function () {

                var c = this.field;
                if (!(c.initField === undefined)) {
                   c.initField(this, function (nodes) {
                    }, this.entity[c.field], c)
                }


        }
    }
}

</script>














// WEBPACK FOOTER //
// formtext_list_item.vue?0b091fe3